//
import jsPDF from 'jspdf'
import 'jspdf-autotable'

//
import PaymentVerifyService from '@/services/API/paymentVerify'
import CustomerReceivablePaymentService from '@/services/API/customerReceivablePayment'

/**
 *
 */
export default async id => {
    //
    const customerReceivablePayments = await CustomerReceivablePaymentService.fetchBy(
            'sl_ground_seller_payment_record_id',
            id
        ),
        customerReceivablePayment = customerReceivablePayments.slice().shift(),
        paymentVerify = await PaymentVerifyService.fetchById(id),
        paymentVerifyId = paymentVerify.id || '',
        paymentVerifyBusinessName =
            paymentVerify.sl_customer.business_name.toUpperCase() || '',
        paymentVerifyCreated =
            customerReceivablePayment.created_at.split(' ').shift() || '',
        paymentVerifyInvoices =
            paymentVerify.sl_detail_ground_seller_payment_records.length.toString() ||
            '',
        paymentVerifyRut = paymentVerify.sl_customer.rut || '',
        paymentVerifyAmount = paymentVerify.total.toString() || '',
        bodyHeight = paymentVerifyInvoices * 20 + 100

    //
    console.log(customerReceivablePayment)

    //
    var doc = new jsPDF({ putOnlyUsedFonts: true, orientation: 'landscape' }),
        body = []

    //
    customerReceivablePayment.payments.forEach((payment, index) => {
        //
        console.log(payment)

        //
        const data = JSON.parse(payment.pivot.data)

        //
        body.push([
            payment.type != 'Cheque' ? '$ ' + payment.pivot.amount : '',
            payment.type != 'Cheque' ? '' : '$ ' + payment.pivot.amount,
            customerReceivablePayment.pos_detail_customer_receivable_payments[
                index
            ].sl_customer_receivable.sl_sale_invoice.number,
            '$ ' +
                Number(
                    customerReceivablePayment
                        .pos_detail_customer_receivable_payments[index]
                        .sl_customer_receivable.sl_sale_invoice.total
                ).toFixed(0),
            payment.type != 'Cheque' ? '' : data.serial_number,
        ])
    })

    //
    doc.setFontStyle('bold')
    doc.text('RECIBO COBRANZA', 16, 20)
    doc.setTextColor('#087f23')
    doc.text('N° ' + paymentVerifyId, 16, 28)
    doc.setFontSize(12)
    doc.setFontStyle('normal')
    doc.setTextColor('#000')

    //
    doc.text('RECIBIDO DE:', 16, 42)
    doc.setFontStyle('bold')
    doc.text(paymentVerifyBusinessName, 48, 42)
    doc.setFontStyle('normal')

    //
    doc.text('FECHA:', 200, 42)
    doc.setFontStyle('bold')
    doc.text(paymentVerifyCreated, 218, 42)
    doc.setFontStyle('normal')

    //
    doc.text('ABONO DE FACTURA(S) N°', 16, 50)
    doc.setFontStyle('bold')
    doc.text(paymentVerifyInvoices, 74, 50)
    doc.setFontStyle('normal')

    //
    doc.text('CÓDIGO DE CLIENTE:', 200, 50)
    doc.setFontStyle('bold')
    doc.text(paymentVerifyRut, 247, 50)
    doc.setFontStyle('normal')

    //
    doc.text('EFECTIVO $', 16, 58)
    doc.setFontStyle('bold')
    doc.text(paymentVerifyAmount, 44, 58)
    doc.setFontStyle('normal')

    //
    doc.autoTable({
        head: [
            [
                'MONTO EFECTIVO',
                'MONTO CHEQUE',
                'FACTURAS CANCELADAS',
                'VALOR FACTURA',
                'CHEQUE N°',
            ],
        ],
        headStyles: {
            fillColor: '#fff',
            fontSize: 12,
            fontStyle: 'normal',
            textColor: '#000',
        },
        body,
        bodyStyles: {
            fontSize: 12,
            textColor: '#000',
        },
        theme: 'grid',
        startX: 66,
        startY: 66,
    })

    //
    doc.setFontStyle('bold')
    doc.text('CLIENTE', 50, bodyHeight)
    doc.text('COBRADOR', 125, bodyHeight)
    doc.text('TIMBRE TESORERÍA', 200, bodyHeight)

    //
    doc.save(['recibo-cobranza-' + id + '.pdf'].join(''))
}
